'use client';

import { Wifi, WifiOff } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useUpdateEffect } from 'react-use';
import { toast } from 'sonner';

import { useDebouncedNetworkState } from '@/components/providers/debounced-network-state-provider';
import { useReadOnly } from '@/components/providers/read-only-provider';
import { useToasterId } from '@/components/toaster-context';

const TOAST_ID = 'network-status';

export function NetworkStatusMonitor() {
  const isReadOnly = useReadOnly();
  const t = useTranslations();
  const { online, previous } = useDebouncedNetworkState();
  const toasterId = useToasterId();

  useUpdateEffect(() => {
    if (isReadOnly) return;
    if (!online && previous === true) {
      toast.error(t('networkStatus.offline'), {
        id: TOAST_ID,
        duration: Infinity,
        toasterId,
        icon: <WifiOff className="h-5 w-5" />,
      });
      return;
    }

    if (online && previous === false) {
      toast.success(t('networkStatus.online'), {
        id: TOAST_ID,
        duration: 3000,
        toasterId,
        icon: <Wifi className="h-5 w-5" />,
      });
    }
  }, [isReadOnly, online, previous, t, toasterId]);

  return null;
}
